/* @flow */

import { createSelector } from '@reduxjs/toolkit';

/*
|------------------------------------------------------------------------------
| INPUTS
|------------------------------------------------------------------------------
*/

const _segment = (state) => state.app.support.contact;

const _getContactRequest = (state) => _segment(state).isFetching;
const _getContactFailure = (state) => _segment(state).failure;
const _getContactSuccess = (state) => _segment(state).success;

/*
|------------------------------------------------------------------------------
| SELECTORS
|------------------------------------------------------------------------------
*/

export const getContactRequest: (state: Object) => boolean = createSelector(
  [_getContactRequest],
  (x: boolean): boolean => x,
);

export const getContactFailure: (state: Object) => Error = createSelector(
  [_getContactFailure],
  (x: Error): Error => x,
);

export const isSupportContacted: (state: Object) => any = createSelector(
  [_getContactSuccess],
  (x: any): any => x,
);
